<template>
<div class="group-list">
<div class="container-fluid">
  <!--
  <div class="row margin-Top-3Perc">
      <span class=" margin-left-2Perc cursor-pointer pull-left" @click="selectAll()">
            Select all 
     </span>
     <span class="margin-left-1Perc pull-left">
            |
      </span>  
      <span class="margin-left-1Perc pull-left cursor-pointer" @click="deSeclectAll()">
            Deselect all
      </span>
  </div>
  -->
    <div class="table-responsive margin-Top-3Perc overflow-x-hidden">
      <table class="table table-striped ">
          <thead>
            <tr>
              <!-- <th class="text-align-center font-size-15px"></th> -->
              <th class="text-align-center font-size-15px border-right">Group Name</th>
              <th class="text-align-center font-size-15px border-right">IsPublic</th>
              <th class="text-align-center font-size-15px border-right">Created TS</th>
              <th class="text-align-center font-size-15px border-right">Courses</th>
              <th class="text-align-center font-size-15px border-right">Cohorts</th>
              <th class="text-align-center font-size-15px border-right">Participants</th>
              <th class="text-align-center font-size-15px">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="groupObj in getGroupList" :key="groupObj.GroupId" v-bind:groupObj = "groupObj" >
              <!-- <td>
                <input type="checkbox" name="groupDetails" :checked="grp.isSelected">
              </td> --> 
              <td class="border-right">{{groupObj.GroupName}}</td>
              <td class="border-right">{{groupObj.IsPublic ? 'Yes' : 'No'}}</td>
              <td class="border-right">{{formatAndShowDate(groupObj.CreatedTS)}}</td>

              <td class="border-right cursor-pointer text-decoration-underline" @click="viewCourseList($event,true,groupObj)">{{groupObj.CourseCount + ' ' + ((groupObj.CourseCount > 1) ? 'Courses' : 'Course')}} </td>
              <td class="border-right cursor-pointer text-decoration-underline" @click="viewCohortList($event,true,groupObj)">{{groupObj.CohortCount + ' ' + ((groupObj.CourseCount > 1) ? 'Cohorts' : 'Cohort')}} </td>
              <td class="border-right cursor-pointer text-decoration-underline" @click="viewParticipantList($event,true,groupObj)">{{groupObj.ParticipantCount + ' ' + ((groupObj.CourseCount > 1) ? 'Participants' : 'Participant')}} </td>
              
              <td class="cursor-pointer">
                <a class="text-decoration-underline" @click="performUserClickAction($event, 'view_group_meditation', groupObj)">View Meditations</a> |
                <a class="text-decoration-underline" @click="performUserClickAction($event, 'view_group_reflection', groupObj)"> View Reflections</a> |
                <a class="text-decoration-underline" @click="performUserClickAction($event, 'view_scheduled_ms_notif', groupObj)"> View Scheduled MS Notif</a>
              </td>         
            </tr>
          </tbody>
       </table>
    </div>
  </div>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <loader></loader>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
  <view-enrolled-courses v-if="viewEnrolledCourses" v-bind:enrolledCourses="enrolledCourseList" v-bind:selectedGroupObj="selectedGroupObj" @viewOverlay="updateViewEnrolledCoursesFlag"></view-enrolled-courses>
  <view-enrolled-cohorts v-if="viewEnrolledCohorts" v-bind:enrolledCohorts="enrolledCohortList" v-bind:selectedGroupObj="selectedGroupObj" @viewOverlay="updateViewEnrolledCohortsFlag"></view-enrolled-cohorts>
  <view-enrolled-participants v-if="viewEnrolledParticipants" v-bind:enrolledParticipants="enrolledParticipantList" v-bind:selectedGroupObj="selectedGroupObj" @viewOverlay="updateViewEnrolledParticipantsFlag"></view-enrolled-participants>
  <view-associated-leaps-reflection-for-group v-if="openViewGroupReflectionOverlay" :selectedGroupObj="selectedGroupObj" @updateValues="closeVisibleOverlay"></view-associated-leaps-reflection-for-group>
  <view-associated-leaps-meditation-for-group v-if="openViewGroupMeditationOverlay" :selectedGroupObj="selectedGroupObj" @updateValues="closeVisibleOverlay"></view-associated-leaps-meditation-for-group>
  <view-associated-scheduled-ms-notification-for-group v-if="openScheduledMSNotificationOverlay" :selectedGroupObj="selectedGroupObj" @updateValues="closeVisibleOverlay"></view-associated-scheduled-ms-notification-for-group>
</div>
</template>
<script>
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import { cohortService } from '@/server-util/cohort-service'
import { participantService } from '@/server-util/participant-service'
import AlertBox from '@/components/AlertOverlay'
import ViewEnrolledCourseList from '@/components/ViewEnrolledCourseListUsingGroup'
import ViewEnrolledCohortList from '@/components/ViewEnrolledCohortListUsingGroup'
import ViewEnrolledParticipantList from '@/components/ViewEnrolledParticipantListUsingGroup'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import { find } from 'lodash'
import ViewAssociatedLeapsReflectionForGroup from './group/ViewAssociatedLeapsReflectionForGroup'
import ViewAssociatedScheduledMSNotificationForGroup from './group/ViewAssociatedScheduledMSNotificationForGroup'
import ViewAssociatedLeapsMeditationForGroup from './group/ViewAssociatedLeapsMeditationForGroup'
export default {
  props: ['groupList'],
  created: function () {
    this.readQueryParam()
  },
  computed: {
    getGroupList: {
      get: function () {
        return this.groupList
      }
    },
    getAvailableleapsMeditationForGroupList: {
      get: function () {
        return this.$store.state.availableLeapsMeditationForGroupList
      }
    }
  },
  data: function () {
    return {
      isChecked: false,
      groupDetails: [],
      viewEnrolledCourses: false,
      viewEnrolledCohorts: false,
      viewEnrolledParticipants: false,
      selectedGroupObj: null,
      enrolledCourseList: [],
      enrolledCohortList: [],
      enrolledParticipantList: [],
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      openViewGroupMeditationOverlay: false,
      openViewGroupReflectionOverlay: false,
      openScheduledMSNotificationOverlay: false
    }
  },
  name: 'group-list',
  methods: {
    performUserClickAction: function (event, operationName, groupObj) {
      this.selectedGroupObj = groupObj
      switch (operationName) {
        case 'view_group_meditation':
          this.$store.state.isOverlayVisible = true
          this.openViewGroupMeditationOverlay = true
          break
        case 'view_group_reflection':
          this.$store.state.isOverlayVisible = true
          this.openViewGroupReflectionOverlay = true
          break
        case 'view_scheduled_ms_notif':
          this.$store.state.isOverlayVisible = true
          this.openScheduledMSNotificationOverlay = true
          break
      }
    },
    readQueryParam: function () {
      const groupId = this.$route.query.groupId
      this.$store.state.hightLightOptionExplictly = true
      if (groupId !== undefined && groupId !== 'undefined' && groupId !== null && groupId !== 'null' && groupId !== '') {
        this.selectedGroupObj = find(this.groupList, (currGroupObj) => {
          return currGroupObj.GroupId === groupId
        })
        if (this.selectedGroupObj === undefined || this.selectedGroupObj === 'undefined' || this.selectedGroupObj === null || this.selectedGroupObj === 'null' || groupId === '') {
          this.selectedGroupObj = -1
        }
      }
      const openReflectionPopup = this.$route.query.openReflectionPopup
      if (openReflectionPopup !== undefined && openReflectionPopup !== 'undefined' && openReflectionPopup !== null && openReflectionPopup !== 'null' && openReflectionPopup !== '') {
        if (this.selectedGroupObj !== -1) {
          this.performUserClickAction(null, 'view_group_reflection', this.selectedGroupObj)
        }
      }
      const openMeditationPopup = this.$route.query.openMeditationPopup
      if (openMeditationPopup !== undefined && openMeditationPopup !== 'undefined' && openMeditationPopup !== null && openMeditationPopup !== 'null' && openMeditationPopup !== '') {
        if (this.selectedGroupObj !== -1) {
          this.performUserClickAction(null, 'view_group_meditation', this.selectedGroupObj)
        }
      }
    },
    closeVisibleOverlay: function () {
      this.openViewGroupMeditationOverlay = false
      this.openViewGroupReflectionOverlay = false
      this.openScheduledMSNotificationOverlay = false
      this.$store.state.isOverlayVisible = false
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    viewCourseList: function (event, flagToUpdate, selectedGroupObj) {
      // this.viewEnrolledCourses = flagToUpdate
      this.selectedGroupObj = selectedGroupObj
      if (selectedGroupObj.CourseCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No course found in \'' + selectedGroupObj.GroupName + '\'.'
        return
      }
      this.getEnrolledCourses()
    },
    viewCohortList: function (event, flagToUpdate, selectedGroupObj) {
      // this.viewEnrolledCourses = flagToUpdate
      this.selectedGroupObj = selectedGroupObj
      if (selectedGroupObj.CohortCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No cohort found in \'' + selectedGroupObj.GroupName + '\'.'
        return
      }
      this.getEnrolledCohorts()
    },
    viewParticipantList: function (event, flagToUpdate, selectedGroupObj) {
      // this.viewEnrolledCourses = flagToUpdate
      this.selectedGroupObj = selectedGroupObj
      if (selectedGroupObj.ParticipantCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No participant found in \'' + selectedGroupObj.GroupName + '\'.'
        return
      }
      this.getEnrolledParticipants()
    },
    updateViewEnrolledCoursesFlag (value) {
      // AK: used to close the overlay (view enrolled courses page) by pressing Close
      this.viewEnrolledCourses = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateViewEnrolledCohortsFlag (value) {
      // AK: used to close the overlay (view enrolled cohort page) by pressing Close
      this.viewEnrolledCohorts = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateViewEnrolledParticipantsFlag (value) {
      // AK: used to close the overlay (view enrolled Participant page) by pressing Close
      this.viewEnrolledParticipants = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    getEnrolledCourses: function () {
      var storeObj = this.$store
      var _this = this
      // alert(this.LessonObj.ModuleId)
      if (
        this.selectedGroupObj.GroupId !== undefined ||
        this.selectedGroupObj.GroupId !== null
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        groupService
          .getCourseList(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCourseList
                this.enrolledCourseList = responseObj.data
                // AK: Hide Spinner after recieving Enrolled course list and show overlay
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.viewEnrolledCourses = true
                // AK: Disable Background Scrolling
                this.$store.state.isOverlayVisible = true

                // console.log(JSON.stringify(this.enrolledCourseList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'GroupId is NULL hence declined LOADING ENROLLED COURSE LIST OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getEnrolledCohorts: function () {
      var storeObj = this.$store
      var _this = this
      // alert(this.LessonObj.ModuleId)
      if (
        this.selectedGroupObj.GroupId !== undefined ||
        this.selectedGroupObj.GroupId !== null
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortList(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCohortList
                this.enrolledCohortList = responseObj.data
                // AK: Hide Spinner after recieving Enrolled Cohort list and show overlay
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.viewEnrolledCohorts = true
                // AK: Disable Background Scrolling
                this.$store.state.isOverlayVisible = true
                // console.log(JSON.stringify(this.enrolledCohortList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'GroupId is NULL hence declined LOADING ENROLLED COHORT LIST OPERATION'
        )
      }
    },
    getEnrolledParticipants: function () {
      var storeObj = this.$store
      var _this = this
      // alert(this.LessonObj.ModuleId)
      if (
        this.selectedGroupObj.GroupId !== undefined ||
        this.selectedGroupObj.GroupId !== null
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        participantService
          .getParticipantList(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCourseList
                this.enrolledParticipantList = responseObj.data
                // AK: Hide Spinner after recieving Enrolled course list and show overlay
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.viewEnrolledParticipants = true
                // AK: Disable Background Scrolling
                this.$store.state.isOverlayVisible = true
                // console.log(JSON.stringify(this.enrolledParticipantList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'GroupId is NULL hence declined LOADING ENROLLED COURSE LIST OPERATION'
        )
      }
    }
  },
  components: {
    'view-enrolled-courses': ViewEnrolledCourseList,
    'alert-box': AlertBox,
    'view-enrolled-cohorts': ViewEnrolledCohortList,
    'view-enrolled-participants': ViewEnrolledParticipantList,
    'loader': Loader,
    'view-associated-leaps-reflection-for-group': ViewAssociatedLeapsReflectionForGroup,
    'view-associated-leaps-meditation-for-group': ViewAssociatedLeapsMeditationForGroup,
    'view-associated-scheduled-ms-notification-for-group': ViewAssociatedScheduledMSNotificationForGroup
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}

.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.group-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
a{
  color: #2c3e50 !important;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}

</style>


// WEBPACK FOOTER //
// src/components/GroupList.vue